async function loadThankYouShape(url) {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Could not load thank-you shape: ${response.status}`);
  }

  const svg = new DOMParser().parseFromString(await response.text(), 'image/svg+xml');
  const paths = [...svg.querySelectorAll('path')];
  const viewBox = svg.documentElement.getAttribute('viewBox')?.trim().split(/[\s,]+/).map(Number);

  if (svg.querySelector('parsererror') || !paths.length || viewBox?.length !== 4 ||
      !viewBox.every(Number.isFinite) || viewBox[2] <= 0 || viewBox[3] <= 0) {
    throw new Error('Invalid thank-you SVG shape');
  }

  const [x, y, width, height] = viewBox;
  const scale = 25 / width;

  // Draw vectors directly: avoid Safari's ImageBitmap/createPattern rendering path.
  return {
    shape: confetti.shapeFromPath({
      path: paths.map((path) => path.getAttribute('d')).join(' '),
      matrix: [scale, 0, 0, scale, -(x + width / 2) * scale, -(y + height / 2) * scale],
    }),
    color: paths[0].getAttribute('fill') || '#282322',
  };
}

async function runThankYouConfetti() {
  const elements = [...document.querySelectorAll('[data-thankyou-shape]')];
  if (!elements.length || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  let canvas;
  let fireConfetti;

  try {
    const shapes = await Promise.all(elements.map((el) => loadThankYouShape(el.dataset.thankyouShape)));
    canvas = document.createElement('canvas');
    canvas.className = 'thankyou-animation__canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);

    // Keep rendering on the main thread, without OffscreenCanvas or a worker.
    fireConfetti = confetti.create(canvas, { resize: true, useWorker: false, disableForReducedMotion: true });
    const count = windowWidth() < breakpointMd ? 30 : 70;
    const defaults = {
      origin: { y: 1.02 },
      ticks: 2000,
      drift: (Math.random() - 0.5) * 1.5,
      scalar: 1.1,
    };

    const fire = (particleRatio, opts) => {
      const particleCount = Math.floor(count * particleRatio);

      // Each SVG has one fill color; keep that color attached to its shape.
      return shapes.map(({ shape, color }, index) => {
        const shapeCount = Math.floor(particleCount / shapes.length) + (index < particleCount % shapes.length ? 1 : 0);
        if (!shapeCount) {
          return Promise.resolve();
        }

        return fireConfetti({
          ...defaults,
          ...opts,
          particleCount: shapeCount,
          shapes: [shape],
          colors: [color],
        });
      });
    };

    await Promise.all([
      ...fire(0.25, {
        spread: windowWidth() < breakpointMd ? 35 : 52,
        startVelocity: windowWidth() < breakpointMd ? 95 : 121,
      }),
      ...fire(0.2, {
        spread: windowWidth() < breakpointMd ? 25 : 50,
      }),
      ...fire(0.35, {
        spread: windowWidth() < breakpointMd ? 42 : 105,
        decay: 0.91,
        scalar: 1.1,
      }),
      ...fire(0.35, {
        spread: windowWidth() < breakpointMd ? 42 : 90,
        startVelocity: 75,
        decay: 0.92,
        scalar: 1.5,
      }),
      ...fire(0.1, {
        spread: windowWidth() < breakpointMd ? 41 : 105,
        startVelocity: 95,
      }),
    ]);
  } catch (error) {
    // An optional animation must not prevent the order confirmation from working.
    console.warn('Thank-you animation skipped:', error);
  } finally {
    fireConfetti?.reset();
    canvas?.remove();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('.sc-purchase-process-info-04')) {
    runThankYouConfetti();
  }
});
